
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/albums",
      function () {
        return require("private-next-pages/albums/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/albums"])
      });
    }
  